import React from 'react';
import styles from './styles.module.scss';
import Success from './assets/Success.svg?react';
import Warning from './assets/Warning.svg?react';
import Info from './assets/Info.svg?react';
import BadConnection from './assets/BadConnection.svg?react';

type Props = {
    text: string;
    type: 'success' | 'warning' | 'info' | 'bad-connection';
};

export const Notification: React.FC<Props> = ({ text, type }) => {
    let icon;
    switch (type) {
        case 'success':
            icon = <Success className={styles.icon} />;
            break;
        case 'warning':
            icon = <Warning className={styles.icon} />;
            break;
        case 'info':
            icon = <Info className={styles.icon} />;
            break;
        case 'bad-connection':
            icon = <BadConnection className={styles.icon} />;
            break;
        default:
            icon = <Info className={styles.icon} />;
    }

    return (
        <div className={styles.notification}>
            {icon}
            <span className={styles.text}>{text}</span>
        </div>
    );
};
